import { Component } from 'react'
import './OutpatientHome.css'
import {
  TextField, IconButton, Tooltip, Box, Typography, Button, ButtonGroup,
  Menu, MenuItem, Stack, Dialog, DialogContent, DialogActions, FormControlLabel,
  Checkbox, Drawer, Autocomplete, TableCell, TableRow, Modal, Table, TableHead, TableBody
} from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { ImagePaths } from '../../../Utility/ImagePaths';
import { AppointmentCard, BillSuccessPoPUp, CommonPatientDetails, NewCommonPatientDetails, ReasonPopup, ConfirmPopup } from '../../../Components/Common Components/CommonComponents';
import { DataGrid, gridNumberComparator } from '@mui/x-data-grid';
import CommonGridHeader, { PovEditPopup } from '../../../Components/Common Components/CommonComponents';
import { Colors } from '../../../Styles/Colors';
import { withTranslation } from 'react-i18next';
import NextAppointments from './NextAppointments';
import RestAPIService from '../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../Utility/API/Serviceurls';
import { DateTime } from 'luxon';
import ToastMsg from '../../../Components/ToastMsg/ToastMsg';
import { clearCachevalue, getCachevalue, localGetItem, setCachevalue } from '../../../Utility/Services/CacheProviderService';
import { cmt_Char_limit, appointmentSet, sliceSet, appointment_Status_other } from '../../../Utility/Constants';
import { AmountFormat, CheckAccessFunc, CheckCashCounterAccess, calculateWaitingTime } from '../../../Components/CommonFunctions/CommonFunctions';
import PaymentsIcon from '@mui/icons-material/Payments';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ReportIcon from '@mui/icons-material/Report';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

class OutpatientHome extends Component {
  constructor(props) {
    super(props)
    this.state = {
      datePicker: new Date(),
      AptTblData: [],
      patientCount: {},
      totalAppointment: {},
      anchorEl: null,
      selectedRow: null,
      selectedOption: "",
      isSelected: false,
      selectedID: "",
      selectedCard: '',
      SelectedPatientDetails: {},
      waitingCmts: false,
      deletedPopup: false,
      cancelAppointment: false,
      page: 0,
      pageSize: 30,
      waitCmtText: '',
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: '',
      timeDiff: null,
      SelectedDoctorID: "",
      DoctorsList: [],
      DatePickerOpen: false,
      tokenNum: '',
      barcodeHeader: false,
      creditBillData: [],
      opCreditBill: {},
      receiptID: null,
      pharmacReceipt: null,
      onAddComment: false,
      povText: {},
      ispovPopOpen: false,
      onChangePov: false,
      FilterOpen: false,
      Rescheduled: false,
      Cancelled: false,
      Transferred: false,
      openTransferList: false,
      transDatePickerOpen: false,
      datePickerTrans: new Date(),
      transDataList: [],
      transPage: 0,
      transPageSize: 10,
      loading: false,
      specializationList: [],
      balanceVisible: false,
      balance_details: {},
      balanceAmount: null,
      timers: {},
      refreshCount: 0,
    }
    this.intervalRefs = {};
  }

  componentDidMount() {
    let DoctorID = JSON.parse(getCachevalue("SelectedDoctorID"))
    let selectedDate = JSON.parse(getCachevalue('SelectedOPDate'))
    // uncommented for doctor list api usage
    this.getDoctorsList()
    this.getSpecializationData()
    this.getTransListData()
    if (DoctorID !== this.state.SelectedDoctorID && ((DoctorID != null && DoctorID != undefined))) {
      this.setState({ SelectedDoctorID: DoctorID, datePicker: selectedDate ? selectedDate : new Date() }, () => {
        clearCachevalue('SelectedOPDate')
        this.getPatientDetails()
      })
    } else {
      this.setState({ datePicker: selectedDate ? selectedDate : new Date() }, () => {
        clearCachevalue('SelectedOPDate')
        this.getPatientDetails()
      })
    }
  }

  componentDidUpdate(prevProps, prevState) {
    let DoctorID = JSON.parse(getCachevalue("SelectedDoctorID"))
    let selectedDate = JSON.parse(getCachevalue('SelectedOPDate'))
    var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
    if (prevProps.history?.location?.state?.NewAppointmentCreated) {
      this.successMsgFunc(prevProps.history?.location?.state?.NewMessage)
      this.props.history.push({ state: { NewAppointmentCreated: false } })
    }
    if (DoctorID !== this.state.SelectedDoctorID && ((DoctorID !== null && DoctorID !== undefined))) {
      this.setState({ SelectedDoctorID: DoctorID, datePicker: selectedDate ? selectedDate : new Date() }, () => {
        clearCachevalue('SelectedOPDate')
        this.getPatientDetails()
      })
    }
    if (prevProps.history?.location?.state?.RequestBool) {
      this.successMsgFunc(this.props.history?.location?.state?.RequestMessage)
      this.setState({ datePicker: selectedDate ? selectedDate : new Date() }, () => {
        clearCachevalue('SelectedOPDate')
        this.getPatientDetails()
      })
      this.props.history.push({ state: { RequestBool: false } })
    }
    if (
      (JSON.stringify(Object.keys(this.state.timers)) !== JSON.stringify(Object.keys(prevState.timers)) ||
        this.state.refreshCount !== prevState.refreshCount) && myUser?.new_doctor_notes_template
    ) {
      Object.entries(this.state.timers).forEach(([id, timer]) => {
        const shouldRun = timer.startTime && !timer.endTime && !timer.isPaused;

        if (shouldRun && !this.intervalRefs[id]) {
          this.intervalRefs[id] = setInterval(() => {
            this.setState((prev) => {
              const timers = { ...prev.timers };
              const t = timers[id];

              if (!t || t.isPaused || t.endTime) return null;

              timers[id] = {
                ...t,
                currentTime: new Date(),
              };

              return { timers };
            });
          }, 250);
        }

        if ((!shouldRun || timer.endTime) && this.intervalRefs[id]) {
          clearInterval(this.intervalRefs[id]);
          this.intervalRefs[id] = null;
        }
      });
    }
  }

  componentWillUnmount() {
    Object.values(this.intervalRefs).forEach(clearInterval);
    this.intervalRefs = {};
  }

  errorMsgFunc = (message) => {
    this.setState({
      isErrorMsg: true,
      isErrorMsgText: message,
      DisableBtn: false
    })
  }

  successMsgFunc = (message) => {
    this.setState({
      successMsg: true,
      successMsgText: message,
      DisableBtn: false
    })
  }

  LoaderFunction = (key) => {
    this.setState({
      isLoader: key
    })
  }

  ClosesuccessPopUp = () => {
    this.setState({
      receiptID: null,
      pharmacReceipt: null
    })
  }

  getPatientDetails = () => {
    try {
      this.LoaderFunction(true)
      var states = this.state
      var StateDate = new Date(states.datePicker)
      var date = states.datePicker ? DateTime.fromJSDate(StateDate).toFormat('yyyy-MM-dd') : null
      let appointmentFilter = []
      if (states.Rescheduled) {
        appointmentFilter.push("Reschedule")
      }
      if (states.Cancelled) {
        appointmentFilter.push("Cancelled")
      }
      if (states.Transferred) {
        appointmentFilter.push("Transfer")
      }
      appointmentFilter = appointmentFilter.join(",")
      setCachevalue(date, 'OpAppDate')
      setCachevalue(states.selectedCard, 'OPStatus')
      var DoctorId = (JSON.parse(getCachevalue("SelectedDoctorID")) === 0 || JSON.parse(getCachevalue("SelectedDoctorID")) === null || JSON.parse(getCachevalue("SelectedDoctorID")) === undefined) ? "" : JSON.parse(getCachevalue("SelectedDoctorID"));
      if (date === 'Invalid DateTime') {
      } else {
        RestAPIService.getAllTwo(Serviceurls.FO_HOME_OP + `?appointment_date=${date}&appointment_status=${states.selectedCard}&doctor_id=${DoctorId}&appointment_filter=${appointmentFilter}`)
          .then(response => {
            if (response.data.status === "success") {
              this.setState({
                AptTblData: response.data.data ? response.data.data : [],
                patientCount: response.data.patient_count ? response.data.patient_count : {},
              }, () => {
                this.state.AptTblData?.forEach(element => {
                  element.patientDetails = `${element.patient_name || ""} ${element.patient_account_numbers || ""} ${element?.patient_mobile_number || ""} ${element?.doctor_name || ""} ${element?.patient_address_1 || ""} ${element?.patient_address_2 || ""} ${element?.patient_city || ""} ${element?.father_name || ""} ${element?.mother_name || ""} ${element?.patient_tag_name || ""}`
                })
                this.LoaderFunction(false)
                this.GetStatusCount(date, DoctorId)
                this.updateTimersFromPatientData(response.data.data || []);
              }
              );
            }
          }).catch(e => {
            this.LoaderFunction(false)
            if (e?.response?.data?.status === "fail") {
              this.errorMsgFunc(e.response.data.message)
            } else {
              this.errorMsgFunc(e.message)
            }
          })
      }
    } catch (e) {
      this.LoaderFunction(false)
      this.errorMsgFunc(e.message)
    }
  }

  updateTimersFromPatientData = (patientData) => {
    const updatedTimers = {};

    patientData.forEach((row) => {
      const id = row.appointment_id;
      const dilation = row.dilation_details ? row.dilation_details?.[0] : {};
      if (!dilation?.start_time) return;

      const startTime = new Date(dilation.start_time);
      const endTime = dilation.end_time ? new Date(dilation.end_time) : null;
      const isPaused = dilation.is_paused ?? false;
      const pauseTime = dilation.pause_time ? new Date(dilation.pause_time) : null;
      const pauseResumeLog = dilation.pause_resume_log || [];

      const totalPausedMs = this.calculateTotalPausedTime(
        pauseResumeLog,
        endTime,
        isPaused,
        pauseTime
      );

      const effectiveStartTime = new Date(startTime.getTime() + totalPausedMs);
      const currentTime = endTime ? endTime : isPaused && pauseTime ? pauseTime : new Date();

      updatedTimers[id] = {
        startTime: effectiveStartTime,
        originalStartTime: startTime,
        endTime,
        currentTime,
        isPaused,
        pauseStartTime: isPaused ? pauseTime : null,
        totalPausedMs,
      };
    });

    if (Object.keys(updatedTimers).length > 0) {
      this.setState((prevState) => ({
        timers: { ...prevState.timers, ...updatedTimers },
      }));
    }
  };

  calculateTotalPausedTime = (log = [], endTime = null, isPaused = false, pauseTime = null) => {
    let totalPausedMs = 0;

    for (let i = 0; i < log.length; i++) {
      const pauseEntry = log[i];
      const resumeEntry = log[i + 1];

      if (pauseEntry.pause && resumeEntry?.resume) {
        const pause = new Date(pauseEntry.pause).getTime();
        const resume = new Date(resumeEntry.resume).getTime();
        totalPausedMs += resume - pause;
        i++;
      } else if (pauseEntry.pause && !resumeEntry) {
        const pause = new Date(pauseEntry.pause).getTime();
        let virtualResume;

        if (endTime) {
          virtualResume = new Date(endTime).getTime();
        } else if (isPaused && pauseTime) {
          virtualResume = new Date(pauseTime).getTime();
        } else {
          virtualResume = new Date().getTime();
        }

        totalPausedMs += virtualResume - pause;
      }
    }

    return totalPausedMs;
  };

  formatTimeDiff = (originalStart, current, totalPaused = 0) => {
    const s = new Date(originalStart).getTime();
    const e = new Date(current).getTime();
    const diff = e - s - totalPaused;

    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    return (
      <Typography fontSize={'0.8vw'} fontWeight={600} color={diff > 1200000 ? 'red' : 'black'}>
        {diff > 0 ? `${hours} Hr : ${minutes} Min : ${seconds} Sec` : '0 Hr : 0 Min : 0 Sec'}
      </Typography>
    );
  };

  GetStatusCount = (date, DoctorId) => {
    try {
      RestAPIService.getAll(Serviceurls.FO_PATIENT_COUNT_DETAILS_GET + `?appointment_date=${date}&doctor_id=${DoctorId}`).
        then((response) => {
          if (response.data.status === "success") {
            this.setState({
              totalAppointment: response.data.data ? response.data.data : {}
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.LoaderFunction(false)
            this.errorMsgFunc(error.response.data.message)
          } else {
            this.LoaderFunction(false)
            this.errorMsgFunc(error.message)
          }
        })
    } catch (error) {
      this.LoaderFunction(false)
      this.errorMsgFunc(error.message)
    }
  }

  postPatientStatus = (status, id, comments, waitTime, rowData) => {
    try {
      var states = this.state
      var data = {
        "appointment_id": id,
        "appointment_status": status,
      }
      if(rowData && !waitTime){
        const waiting_time = calculateWaitingTime(rowData);
        data["waiting_timer"] = waiting_time
      } else {
        data["waiting_timer"] = waitTime ? waitTime : null
      }
      if (states.waitingCmts) {
        data['waiting_comment'] = comments
      }
      if (states.cancelAppointment) {
        data['cancel_reason'] = comments.replace(/\s+/g, ' ').trim()
      }
      RestAPIService.create(data, Serviceurls.FO_HOME_OP_STATUS)
        .then(response => {
          if (response.data.status == "success") {
            this.getPatientDetails()
            this.setState({
              waitCmtText: '',
              DisableBtn: false
            })
          }
        }).catch(e => {
          this.setState({ DisableBtn: false })
          if (e?.response?.data?.status === "fail") {
            this.errorMsgFunc(e.response.data.message)
          } else {
            this.errorMsgFunc(e.message)
          }
        })
    } catch (e) {
      this.setState({ DisableBtn: false })
      this.errorMsgFunc(e.message)
    }
  }

  getDoctorsList() {
    try {
      RestAPIService.getAll(Serviceurls.FO_CONFIG_OPDOCTORNAME).
        then((response) => {
          if (response.data.status === "success") {
            this.setState({
              DoctorsList: response.data.data.filter((item) => (item.specialization_active === true))
            })
          }
          else {
            this.errorMsgFunc(response.data.message)
          }
        }).catch((e) => {
          this.errorMsgFunc(e.message)
        })
    }
    catch (e) {
      this.errorMsgFunc(e.message)
    }
  }

  getPatientPrescriptionPrint = () => {
    try {
      let APIUrl = ""
      APIUrl = Serviceurls.PRINT_PRESCRIPTION + "?appointment_id=" + this.state.SelectedPatientDetails?.appointment_id + "&patient_id=" + this.state.SelectedPatientDetails?.patient_id + "&doctor_id=" + this.state.SelectedPatientDetails?.doctor_id + "&export_type=pdf"
      RestAPIService.getAllTwo(APIUrl).
        then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.setState({ selectedOption: "" })
        }).catch((error) => {
          this.errorMsgFunc(error.response?.data?.message);
          this.setState({ selectedOption: "" })
        })
    } catch (error) {
      this.errorMsgFunc(error.message)
      this.setState({ selectedOption: "" })
    }
  }

  getPatientDoctorNotesPrint = () => {
    try {
      var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
      let APIUrl = ""
      const UserData = JSON.parse(localGetItem("loggedInUserInfo"));
      const baseUrl = UserData?.new_doctor_notes_template_others ?
        Serviceurls.SARAS_DOC_VISIT_REPORT_GET :
        Serviceurls.DOCTOR_NOTES_PRINT;
      APIUrl = baseUrl + "?appointment_id=" + this.state.SelectedPatientDetails?.appointment_id + "&patient_id=" + this.state.SelectedPatientDetails?.patient_id + "&doctor_notes=all" + "&doctor_id=" + this.state.SelectedPatientDetails?.doctor_id
      RestAPIService.getAllPrint(APIUrl)
        .then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.setState({ selectedOption: "" })
        }).catch((error) => {
          this.errorMsgFunc(error.response?.data?.message);
          this.setState({ selectedOption: "" })
        })
    } catch (error) {
      this.errorMsgFunc(error.message)
      this.setState({ selectedOption: "" })
    }
  }

  getCustomizedCardPrint = () => {
    try {
      RestAPIService.getAll(Serviceurls.OP_CUSTOMIZED_CARD_PRINT + "?patient_id=" + this.state.SelectedPatientDetails?.patient_id + "&appointment_id=" + this.state.SelectedPatientDetails?.appointment_id).
        then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.setState({ selectedOption: "" })
        }).catch((error) => {
          this.errorMsgFunc(error.response?.data?.message);
          this.setState({ selectedOption: "" })
        })
    } catch (error) {
      this.setState({ selectedOption: "" })
      this.errorMsgFunc(error.message)
    }
  }

  getPatientOpCardPrint = (barcodeHeader) => {
    try {
      let Url = ""
      if (barcodeHeader) {
        Url = Serviceurls.OP_CARD_PRINT + "?patient_id=" + this.state.SelectedPatientDetails?.patient_id + "&appointment_id=" + this.state.SelectedPatientDetails?.appointment_id + "&header=false"
      } else {
        Url = Serviceurls.OP_CARD_PRINT + "?patient_id=" + this.state.SelectedPatientDetails?.patient_id + "&appointment_id=" + this.state.SelectedPatientDetails?.appointment_id
      }
      RestAPIService.getAll(Url).
        then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.setState({ selectedOption: "" })
        }).catch((error) => {
          this.errorMsgFunc(error.response?.data?.message);
          this.setState({ selectedOption: "" })
        })
    } catch (error) {
      this.setState({ selectedOption: "" })
      this.errorMsgFunc(error.message)
    }
  }

  getPatientOpBillDetailPrint = () => {
    try {
      RestAPIService.getAll((Serviceurls.NEW_OP_DETAILED_BILL_PRINT) + "?appointment_id=" + this.state.SelectedPatientDetails?.appointment_id).
        then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.setState({ selectedOption: "" })
        }).catch((error) => {
          if (error.response?.data?.message) {
            this.errorMsgFunc(error.response?.data?.message);
          } else {
            this.errorMsgFunc(error.message);
          }
          this.setState({ selectedOption: "" })
        })
    } catch (error) {
      this.setState({ selectedOption: "" })
      this.errorMsgFunc(error.message)
    }
  }

  getPatientOpSummaryBillPrint = () => {
    try {
      RestAPIService.getAll((Serviceurls.NEW_OP_SUMMARY_BILL_PRINT) + "?appointment_id=" + this.state.SelectedPatientDetails?.appointment_id).
        then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.setState({
            selectedOption: ""
          })
        }).catch((error) => {
          this.setState({ selectedOption: "" })
          this.errorMsgFunc(error.response?.data?.message);
        })
    } catch (error) {
      this.setState({ selectedOption: "" })
      this.errorMsgFunc(error.message)
    }
  }

  getPatientPresTemplate = () => {
    try {
      let token = this.state.tokenNum ? this.state.tokenNum : null
      RestAPIService.getAllPrint(Serviceurls.OP_PRES_TEMPLATE + "?patient_id=" + this.state.SelectedPatientDetails?.patient_id +
        "&doctor_id=" + this.state.SelectedPatientDetails?.doctor_id +
        "&token_number=" + token + "&appointment_id=" + this.state.SelectedPatientDetails?.appointment_id)
        .then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.setState({ selectedOption: "" })
        }).catch((error) => {
          this.errorMsgFunc(error.response?.data?.message);
          this.setState({ selectedOption: "" })
        })
    } catch (error) {
      this.errorMsgFunc(error.message)
      this.setState({ selectedOption: "" })
    }
  }

  getCommonBarCodePrint = () => {
    try {
      RestAPIService.getAll(Serviceurls.COMMON_BARCODE_PRINT + "?patient_id=" + this.state.SelectedPatientDetails?.patient_id + "&appointment_id=" + this.state.SelectedPatientDetails?.appointment_id).
        then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.setState({ selectedOption: "" })
        }).catch((error) => {
          if (error.response?.data?.message) {
            this.errorMsgFunc(error.response?.data?.message);
          } else {
            this.errorMsgFunc(error.message);
          }
          this.setState({ selectedOption: "" })
        })
    } catch (error) {
      this.setState({ selectedOption: "" })
      this.errorMsgFunc(error.message)
    }
  }

  OPPatientDataSheetPrint = () => {
    try {
      RestAPIService.getAll(Serviceurls.OP_PATIENT_DATA_PRINT + "?patient_id=" + this.state.SelectedPatientDetails?.patient_id).
        then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.setState({ selectedOption: "" })
        }).catch((error) => {
          if (error.response?.data?.message) {
            this.errorMsgFunc(error.response?.data?.message);
          } else {
            this.errorMsgFunc(error.message);
          }
          this.setState({ selectedOption: "" })
        })
    } catch (error) {
      this.setState({ selectedOption: "" })
      this.errorMsgFunc(error.message)
    }
  }

  getMedicalRecordPrint = () => {
    try {
      RestAPIService.getAll(Serviceurls.MEDICAL_RECORD_PRINT + "?appointment_id=" + this.state.SelectedPatientDetails?.appointment_id).
        then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.setState({ selectedOption: "" })
        }).catch((error) => {
          if (error.response?.data?.message) {
            this.errorMsgFunc(error.response?.data?.message);
          } else {
            this.errorMsgFunc(error.message);
          }
          this.setState({ selectedOption: "" })
        })
    } catch (error) {
      this.setState({ selectedOption: "" })
      this.errorMsgFunc(error.message)
    }
  }
  // Print Appointment list for 4.0 start
  printAppList() {
    try {
      var date = getCachevalue('OpAppDate')
      var opstatus = getCachevalue('OPStatus')
      var DoctorId = (JSON.parse(getCachevalue("SelectedDoctorID")) === 0 || JSON.parse(getCachevalue("SelectedDoctorID")) === null || JSON.parse(getCachevalue("SelectedDoctorID")) === undefined) ? "" : JSON.parse(getCachevalue("SelectedDoctorID"));
      this.setState({ disableBtn: true })
      RestAPIService.PrintPDF(Serviceurls.FO_APPOINTMENT_PRINT + "?appointment_date=" + date + "&doctor_id=" + DoctorId + "&appointment_status=" + opstatus).
        then((response) => {
          if (response) {
            //Create a Blob from the PDF Stream
            const file = new Blob(
              [response.data],
              { type: 'application/pdf' });
            //Build a URL from the file
            const fileURL = URL.createObjectURL(file);
            //Open the URL on new Window
            window.open(fileURL);
            this.setState({ disableBtn: false })
          }
        }).catch((error) => {
          this.setState({ disableBtn: false })
          console.log(error.message)
        })
    } catch (e) {
      this.setState({ disableBtn: false })
      console.log(e.message)
    }
  }

  renderOPHeader = () => {
    const { t } = this.props
    let userData = JSON.parse(localGetItem("loggedInUserInfo"))
    return (
      <div className='eMed_OP_AptHead'>
        <p>{t('OPAppointments')}</p>
        <div className='eMed_Header_OP_home_div'>
          {
            this.state.datePicker < new Date() && (DateTime.fromJSDate(new Date(this.state.datePicker)).toFormat('yyyy-MM-dd') !== DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd')) && localGetItem("noShowStatus") === "true" ?
              <Button
                className={this.state.selectedCard === 'No Show' ? "eMed_Header_OP_Noshow_btn_on" : 'eMed_Header_OP_Noshow_btn'} size='small'
                onClick={() => { this.setState({ selectedCard: 'No Show' }, () => { this.getPatientDetails() }) }}>
                {`No Show ( ${this.state.totalAppointment?.no_show ? this.state.totalAppointment?.no_show : 0} )`}
              </Button> : null
          }
          {userData?.is_qms_enabled ?
            <Button
              variant='contained'
              sx={{ textTransform: 'capitalize', mr: '0.5dvw' }}
              size='small'
              onClick={() => { this.setState({ openTransferList: true }) }}>
              {`transferred List (${this.state.transDataList?.length ? this.state.transDataList?.length : 0})`}
            </Button> : null
          }

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              open={this.state.DatePickerOpen}
              onOpen={() => { this.setState({ DatePickerOpen: true }) }}
              onClose={() => { this.setState({ DatePickerOpen: false }) }}
              value={this.state.datePicker}
              name={"datePicker"}
              inputFormat='DD-MM-YYYY'
              views={["year", "month", "day"]}
              onChange={
                (newDate) => {
                  this.setState({
                    datePicker: newDate,
                    selectedCard: ''
                  }, () => {
                    setCachevalue(JSON.stringify(this.state.datePicker), "SelectedOPDate")
                    this.getPatientDetails()
                  });
                }}
              renderInput={(params) => <TextField onKeyDown={(e) => e.preventDefault()} style={{ width: '10vw' }} size='small' {...params} onClick={() => { this.setState({ DatePickerOpen: true }) }} />}
            />
          </LocalizationProvider>
          {userData?.is_qms_enabled ?
            <Tooltip title="Filter" placement='top' arrow>
              <Button className='eMed_usrconf_btn' emed_tid='opHome_filter_btn' onClick={() => { this.setState({ FilterOpen: true }) }}>
                <img src={ImagePaths.Filter.default} alt="filter" className='eMed_action_img' />
              </Button>
            </Tooltip>
            : null}
          <Button variant="contained" sx={{ width: "1.5vw !important", height: "2vw !important" }}
            onClick={() => {
              this.printAppList()
            }} disabled={this.state.disableBtn}>
            <img style={{ height: '1.2vw', width: '1.2vw' }} src={ImagePaths.Print.default} alt='Print' />
          </Button>
        </div>
      </div>
    )
  }

  renderPatientType = () => {
    const { t } = this.props
    let { history } = this.props;
    var states = this.state

    var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
    var UserData = myUser
    let appointmentStatus = JSON.parse(localGetItem('appointment_status')) ? JSON.parse(localGetItem('appointment_status')) :
      JSON.parse(localGetItem('loggedInUserInfo'))?.appointment_status ? JSON.parse(localGetItem('loggedInUserInfo'))?.appointment_status !== null ? JSON.parse(localGetItem('loggedInUserInfo'))?.appointment_status :
        appointment_Status_other : appointment_Status_other
    return (
      <div className='eMed_OP_AddPatient'>
        <div className='eMed_OP_PatientType_CreateBtn' >
          {UserData?.module_name !== 'nurse' ?
            <div>
              <Tooltip title={t('CreatePatient')} placement='top' arrow>
                <IconButton onClick={() => { history.push({ pathname: "/OPHome/Billing/NewQuickBilling" }) }}>
                  <img className='eMed_OP_AddPatient_Icon' src={ImagePaths.AddNewPatient.default} alt={"Add Patient"} />
                </IconButton>
              </Tooltip>
            </div> : null}
          <div className='eMed_OP_PatientTypeCont'>
            <p className='eMed_OP_TypeNew'><img className='eMed_OP_Patient_Iconcircle' src={ImagePaths.NewPatient.default} alt={'New Patient'} /> {t('NewPatients') + ' (' + (states.patientCount.new_patient ? states.patientCount.new_patient : '0') + ')'}</p>
            <p className='eMed_OP_TypeEstablished'><img className='eMed_OP_Patient_Iconcircle' src={ImagePaths.EstablishedPatient.default} alt={'Review Patient'} /> {t('ReviewPatients') + ' (' + (states.patientCount.review_patient ? states.patientCount.review_patient : '0') + ')'}</p>
            <p className='eMed_OP_TypeEstablished'><img className='eMed_OP_Patient_Iconcircle' src={ImagePaths.ReviewPatient.default} alt={'Old Patient'} /> {t('Old Patients') + ' (' + (states.patientCount.old_patient ? states.patientCount.old_patient : '0') + ')'}</p>
          </div>
        </div>
        <div>
          <div className='eMed_OP_Apt_Cards' style={{ width: "80dvw", placeContent: "end" }}>
            <AppointmentCard onClick={() => { this.setState({ selectedCard: '' }, () => { this.getPatientDetails() }) }} icon={ImagePaths.BookedPatientFill.default} count={states.totalAppointment.total} label={t("All")} color={"#616161"} isSelectedCard={states.selectedCard === "" ? true : false} />
            <AppointmentCard onClick={() => { this.setState({ selectedCard: 'Booked' }, () => { this.getPatientDetails() }) }} icon={ImagePaths.BookedPatientFill.default} count={states.totalAppointment.booked} label={t("Booked")} color={"#616161"} isSelectedCard={states.selectedCard === "Booked" ? true : false} />
            <AppointmentCard onClick={() => { this.setState({ selectedCard: 'Ip Appointment' }, () => { this.getPatientDetails() }) }} icon={ImagePaths.BookedPatientFill.default} count={states.totalAppointment.ip_appointment} label={t("IP Appointment")} color={"#5fbe39"} isSelectedCard={states.selectedCard === "Ip Appointment" ? true : false} />
            <AppointmentCard onClick={() => { this.setState({ selectedCard: 'Arrived' }, () => { this.getPatientDetails() }) }} icon={ImagePaths.StatusArrivedFill.default} count={states.totalAppointment.arrived} label={t("Arrived")} color={"#0461B7"} isSelectedCard={states.selectedCard === "Arrived" ? true : false} />
            {this.state.totalAppointment?.with_nurse > 0 && !appointmentStatus[1]?.is_checked ?
              <AppointmentCard onClick={() => { this.setState({ selectedCard: 'With Nurse' }, () => { this.getPatientDetails() }) }} icon={ImagePaths.StatusNurseFill.default} count={states.totalAppointment.with_nurse} label={t("WithNurse")} color={"#AF2591"} isSelectedCard={states.selectedCard === "With Nurse" ? true : false} /> :
              appointmentStatus[1]?.is_checked ? <AppointmentCard onClick={() => { this.setState({ selectedCard: 'With Nurse' }, () => { this.getPatientDetails() }) }} icon={ImagePaths.StatusNurseFill.default} count={states.totalAppointment.with_nurse} label={t("WithNurse")} color={"#AF2591"} isSelectedCard={states.selectedCard === "With Nurse" ? true : false} /> : null}
            <AppointmentCard onClick={() => { this.setState({ selectedCard: 'With Doctor' }, () => { this.getPatientDetails() }) }} icon={ImagePaths.StatusDoctorFill.default} count={states.totalAppointment.with_doctor} label={t("WithDoctor")} color={"#29B6F6  "} isSelectedCard={states.selectedCard === "With Doctor" ? true : false} />
            {this.state.totalAppointment?.with_counsellor > 0 && !appointmentStatus[6]?.is_checked ?
              <AppointmentCard onClick={() => { this.setState({ selectedCard: 'With Counsellor' }, () => { this.getPatientDetails() }) }} icon={ImagePaths.withCounsellorOn.default} count={states.totalAppointment.with_counsellor ? states.totalAppointment.with_counsellor : 0} label={t("With Counsellor")} color={"#29B6F6  "} isSelectedCard={states.selectedCard === "With Counsellor" ? true : false} /> :
              appointmentStatus[6]?.is_checked ? <AppointmentCard onClick={() => { this.setState({ selectedCard: 'With Counsellor' }, () => { this.getPatientDetails() }) }} icon={ImagePaths.withCounsellorOn.default} count={states.totalAppointment.with_counsellor ? states.totalAppointment.with_counsellor : 0} label={t("With Counsellor")} color={"#29B6F6  "} isSelectedCard={states.selectedCard === "With Counsellor" ? true : false} /> : null}
            <AppointmentCard onClick={() => { this.setState({ selectedCard: 'Completed' }, () => { this.getPatientDetails() }) }} icon={ImagePaths.CompletedPatientFill.default} count={states.totalAppointment.completed} label={t("Completed")} color={"#1E972A"} isSelectedCard={states.selectedCard === "Completed" ? true : false} />
            <AppointmentCard onClick={() => { this.setState({ selectedCard: 'Cancelled' }, () => { this.getPatientDetails() }) }} icon={ImagePaths.CancelPatients.default} count={states.totalAppointment.cancelled} label={t("Cancelled")} color={"#B8170D"} isSelectedCard={states.selectedCard === "Cancelled" ? true : false} />
          </div>
        </div>
      </div>
    )
  }

  scrollCards = (direction) => {
    const scrollAmount = 300;
    if (this.cardsContainer) {
      this.cardsContainer.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  AppointmentTypeIcon(type) {
    const { t } = this.props
    switch (type) {
      case "Telephonic Appointment": return <div className='eMed_OP_AptType_Icon'><Tooltip placement='top' title={t("TelephonicAppointment")} arrow><img className='eMed_OP_Patient_Iconcircle_Appointment' src={ImagePaths.Telephonic.default}></img></Tooltip></div>
      case "Mobile Appointment": return <div className='eMed_OP_AptType_Icon'><Tooltip placement='top' title={t("MobileAppointment")} arrow><img className='eMed_OP_Patient_Iconcircle_Appointment' src={ImagePaths.Phone.default}></img></Tooltip></div>
      case "Online Appointment": return <div className='eMed_OP_AptType_Icon'><Tooltip placement='top' title={t("Online Appointment")} arrow><img className='eMed_OP_Patient_Iconcircle_Appointment' src={ImagePaths.Web.default}></img></Tooltip></div>
      case "Web Appointment": return <div className='eMed_OP_AptType_Icon'><Tooltip placement='top' title={t("WebAppointment")} arrow><img className='eMed_OP_Patient_Iconcircle_Appointment' src={ImagePaths.Web.default}></img></Tooltip></div>
      case "Walk in Appointment": return <div className='eMed_OP_AptType_Icon'><Tooltip placement='top' title={t("WalkAppointment")} arrow><img className='eMed_OP_Patient_Iconcircle_Appointment' src={ImagePaths.Walkin.default}></img></Tooltip></div>
      // case "transfer": return <div className='eMed_OP_AptType_Icon'><Tooltip placement='top' title={t("Transfered")} arrow><img className='eMed_OP_Patient_Iconcircle_Appointment' src={ImagePaths.Transfer.default}></img></Tooltip><span id='eMed_OP_AptTbl_AptText' style={{ fontWeight: '600' }}>{" (Transfered)"}</span></div>
      case "transfer": return <div className='eMed_OP_AptType_Icon'><Tooltip placement='top' title={t("Transferred")} arrow><img className='eMed_OP_Patient_Iconcircle_Appointment' src={ImagePaths.Transfer.default}></img></Tooltip></div>
      default: return <div className='eMed_OP_AptType_Icon'><Tooltip placement='top' title={type === null ? t("Others") : type} arrow><img className='eMed_OP_Patient_Iconcircle_Appointment' src={ImagePaths.DefaultAppointType.default}></img></Tooltip></div>
    }
  }

  moduleBalance(balDetail, balAmount) {
    if (balDetail && Object.keys(balDetail).length > 0) {
      this.setState({ balanceVisible: true, balance_details: balDetail, balanceAmount: balAmount })
    }
  }

  PaymentStatus(BillAmount, ReceivedAmount, BalanceDetails = {}) {
    const balAmount = BillAmount - ReceivedAmount;
    const renderPayment = (Icon, label, amount, color, onClick) => {
      return (
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }} onClick={onClick}>
          <Icon sx={{ fontSize: "0.9vw", marginRight: '0.4vw', color: color }} />
          <Typography color={color} fontSize={"0.8vw"}>{`${label} : ${AmountFormat(amount)} `}</Typography>
        </Box>
      )
    }
    return (
      <Box>
        {renderPayment(PaymentsIcon, 'Bill', BillAmount, '#616161')}
        {renderPayment(CheckCircleIcon, 'Paid', ReceivedAmount, 'green')}
        {renderPayment(ReportIcon, 'Balance', balAmount, '#B8170D',
          (e) => { e.stopPropagation(); this.moduleBalance(BalanceDetails, balAmount) })}
      </Box>
    )
  }

  renderBtn = (label, color = 'primary', toolTitle = null) => {
    const { t } = this.props;
    return (
      <Tooltip title={toolTitle} placement='top' arrow>
      <Button color = {color} sx={{ textTransform: 'capitalize', width: "10vw", backgroundColor: color === 'error' ? '' : Colors.themeDark }}
        size='small' disableElevation variant='contained'>
        {t(label)}
      </Button>
      </Tooltip>
    )
  }

  renderBtnGroup = (toolTitle, disabled, src, onClick) => {
    const { t } = this.props;
    return (
      <Tooltip title={t(toolTitle)} placement='top' arrow>
        <Button id='eMed_OP_Btn' key={toolTitle} onClick={onClick} disabled={disabled}>
          <img className='eMed_OP_AptTbl_Status_Icon' src={src} alt={toolTitle} />
        </Button>
      </Tooltip>
    )
  }

  StatusBtns(data, id) {
    const storedAppointment = localGetItem('appointment_status');
    const storedUserInfo = localGetItem('loggedInUserInfo');

    const appointmentStatus = 
      (storedAppointment && JSON.parse(storedAppointment)) ||
      (storedUserInfo && JSON.parse(storedUserInfo)?.appointment_status) ||
      appointment_Status_other;

    return (
      data.appointment_status === "Completed" ? this.renderBtn("Completed") :
        (data?.transfer_appointment && data?.appointment_status !== 'Cancelled') ? this.renderBtn("Transferred") :
          data.appointment_status === "Cancelled" ? this.renderBtn("Cancelled", "error", `Cancelled Due to ${data?.cancel_reason}`) :
            <div>
              <ButtonGroup size="small" sx={{ backgroundColor: '#E4F2F0' }}>
                {this.renderBtnGroup('Arrived',
                  this.state.DisableBtn || ((data.appointment_status === "Booked" || data.appointment_status === "Ip Appointment" || data.appointment_status === "On Queue") ? false : true),
                  appointmentSet.has(data.appointment_status) ? ImagePaths.StatusArrivedFill.default : ImagePaths.StatusArrived.default,
                  () => {
                    this.setState({ DisableBtn: true },
                      () => {
                      var today = new Date()
                      var date = DateTime.fromJSDate(today).toFormat('yyyy-MM-dd')
                      var AptDate = new Date(data.appointment_date)
                      var AppointmentDate = DateTime.fromJSDate(AptDate).toFormat('yyyy-MM-dd')
                      if (date === AppointmentDate) {
                        this.postPatientStatus('Arrived', id, data.waiting_comment)
                      } else {
                        this.errorMsgFunc("Arrived status can't be changed for future or past dates.")
                      }
                    })
                  }
                )}
                {/* WithNurse */}
                {((this.state.totalAppointment?.with_nurse > 0 && !appointmentStatus[1]?.is_checked) || (appointmentStatus[1]?.is_checked)) ?
                  this.renderBtnGroup('WithNurse',
                    ((data.appointment_status === "Arrived" || data.appointment_status === "With Doctor") ? false : true) || this.state.DisableBtn,
                    sliceSet(1)?.has(data.appointment_status) ? ImagePaths.StatusNurseFill.default : ImagePaths.StatusNurse.default,
                    () => {
                      this.setState({ DisableBtn: true},
                         () => { this.postPatientStatus('With Nurse', id, data.waiting_comment, data.waiting_timer, data) })
                    }
                  ) : null}
                {/* WithDoctor   */}
                {
                  this.renderBtnGroup('WithDoctor',
                    this.state.totalAppointment?.with_nurse > 0 && !appointmentStatus[1]?.is_checked ?
                      ((data.appointment_status === "With Nurse" || data.appointment_status === 'With Counsellor' ? false : true) || this.state.DisableBtn) :
                      appointmentStatus[1]?.is_checked ?
                        ((data.appointment_status === "With Nurse" || data.appointment_status === 'With Counsellor' ? false : true) || this.state.DisableBtn) :
                        ((data.appointment_status === "Arrived" || data.appointment_status === "With Nurse" || data.appointment_status === 'With Counsellor' ? false : true) || this.state.DisableBtn),
                    (sliceSet(2)?.has(data.appointment_status)) ? ImagePaths.StatusDoctorFill.default : ImagePaths.StatusDoctor.default,
                    () => {
                      this.setState({ DisableBtn: true},
                         () => { this.postPatientStatus('With Doctor', id, data.waiting_comment, data.waiting_timer, data) })
                    }
                  )}
                {/* WithCounsellor */}
                {((this.state.totalAppointment?.with_counsellor > 0 && !appointmentStatus[6]?.is_checked) || appointmentStatus[6]?.is_checked) ?
                  this.renderBtnGroup('WithCounsellor',
                    ((data.appointment_status === "With Doctor" ? false : true) || this.state.DisableBtn),
                    (sliceSet(6)?.has(data.appointment_status)) ? ImagePaths.withCounsellorOn.default : ImagePaths.withCounsellorOff.default,
                    () => {
                      this.setState({ DisableBtn: true },
                        () => { this.postPatientStatus('With Counsellor', id, data.waiting_comment) })
                    }
                  ) : null}

                {/* Completed */}
                {this.renderBtnGroup('Completed',
                  (data.appointment_status === 'With Doctor' ||
                    data.appointment_status === 'With Counsellor' || (data.is_nurse && data.token_type === "Nurse"
                      && data.appointment_status === "With Nurse") ? false : true) || this.state.DisableBtn,
                  ImagePaths.StatusCompleted.default,
                  () => {
                    this.setState({ DisableBtn: true}, 
                      () => { this.postPatientStatus('Completed', id, data.waiting_comment) })
                  }

                )}
              </ButtonGroup>
            </div>
    )
  }

  ActionBtn = (data) => {
    const { t } = this.props
    let multi_option = []
    if (data.row.appointment_status === "Booked" || data.row.appointment_status === "Ip Appointment" || data.row.appointment_status === "Arrived") {
      multi_option.push({ label: "Reschedule", value: "Reschedule" })
      multi_option.push({ label: "PrintDoctorNotes", value: "PrintDoctorNotes" })
      multi_option.push({ label: "PrintPrescription", value: "PrintPrescription" })
      multi_option.push({ label: "Customized Print", value: "CustomizedPrint" })
      multi_option.push({ label: "OpBarcode", value: "OpBarcode" })
      multi_option.push({ label: "OpCard", value: "OpCard" })
      multi_option.push({ label: "BillDetails", value: "BillDetails" })
      multi_option.push({ label: "SummaryBill", value: "SummaryBill" })
      multi_option.push({ label: "PresTem", value: "PrescriptionTemplate" })
      multi_option.push({ label: "BarCode", value: "CommonBarcode" })
      multi_option.push({ label: "MedicalRecord", value: "MedicalRecord" })
      multi_option.push({ label: "Patient Data Sheet", value: "DataSheet" })
      if (!data?.row?.transfer_appointment) {
        multi_option.push({ label: "TransAppoint", value: "TransAppoint" })
        multi_option.push({ label: "CancelAppontment", value: "CancelAppontment" })
      }
    }
    else {
      multi_option.push({ label: "NextAppointment", value: "NextAppointment" })
      multi_option.push({ label: "PrintDoctorNotes", value: "PrintDoctorNotes" })
      multi_option.push({ label: "PrintPrescription", value: "PrintPrescription" })
      multi_option.push({ label: "Customized Print", value: "CustomizedPrint" })
      multi_option.push({ label: "OpBarcode", value: "OpBarcode" })
      multi_option.push({ label: "OpCard", value: "OpCard" })
      multi_option.push({ label: "BillDetails", value: "BillDetails" })
      multi_option.push({ label: "SummaryBill", value: "SummaryBill" })
      multi_option.push({ label: "PresTem", value: "PrescriptionTemplate" })
      multi_option.push({ label: "BarCode", value: "CommonBarcode" })
      multi_option.push({ label: "MedicalRecord", value: "MedicalRecord" })
      multi_option.push({ label: "Patient Data Sheet", value: "DataSheet" })
      if (!data?.row?.transfer_appointment) {
        multi_option.push({ label: "TransAppoint", value: "TransAppoint" })
      }
    }
    if (data?.row?.is_emergency) {
      multi_option?.push({ label: "Disable Highlight", value: "ChangeTag" })
    }
    var date = new Date().toISOString().split('T')[0];
    return (
      <div className='eMed_OP_Apt_ActionBtn'>
        <Tooltip title={t('CreateBill')} placement='top' arrow>
          <div>
            <IconButton disabled={(data.row.appointment_status === "Cancelled" || data.row.appointment_status === "No Show") ? true : false} onClick={() => {
              let { history } = this.props;
              setCachevalue(true, 'FromOtherScreen')
              setCachevalue('/OPHome', 'path')
              setCachevalue(true, 'isForCancelBill')
              setCachevalue(true, 'FromCreate')
              history.push({ pathname: '/HospitalBilling/HospitalBilling', state: { patientId: data?.row, appointment_id: data?.row?.appointment_id } })
            }}
            ><img className='eMed_OP_AptTbl_Status_Icon' src={(data.row.appointment_status === "Cancelled" || data.row.appointment_status === "No Show") ? ImagePaths.DisabledCreateBill.default : ImagePaths.BillCreated.default} alt='Create Bill' /></IconButton>
          </div>
        </Tooltip>
        <Tooltip title={t('Receive Payment')} placement='top' arrow>
          <div>
            <IconButton disabled={(CheckCashCounterAccess() || (localGetItem('isNewBilling') === "false")) && CheckAccessFunc("front_office", "Home", "Billing", "Bills", "SubTab")?.editAccess && data.row?.appointment_id && data.row.appointment_status !== "Cancelled" && (((data.row?.bill_amount ? data.row?.bill_amount : 0) - (data.row?.received_amount ? data.row?.received_amount : 0)) > 0) ? false : true}
              onClick={() => {
                this.props?.history?.push({ pathname: "/HospitalBilling/CashCounter", states: { patient_details: { ...data.row, patient_account_number: data?.row?.patient_account_numbers }, return_path: "/OPHome", back_button_lable: "Back to OP Home", module: "op", search_label: "appointment_id", search_value: data.row?.appointment_id } })
              }}>
              <img className='eMed_OP_AptTbl_Status_Icon' src={(CheckCashCounterAccess() || (localGetItem('isNewBilling') === "false")) && CheckAccessFunc("front_office", "Home", "Billing", "Bills", "SubTab")?.editAccess && data.row?.appointment_id && data.row.appointment_status !== "Cancelled" && (((data.row?.bill_amount ? data.row?.bill_amount : 0) - (data.row?.received_amount ? data.row?.received_amount : 0)) > 0) ? ImagePaths.Payment.default : ImagePaths.DisPayment.default} alt='Cancel Appointments' />
            </IconButton>
          </div>
        </Tooltip>
        <div>
          <Tooltip title={t("More")} placement='top' arrow>
            <IconButton
              onClick={(e) => {
                this.setState({
                  anchorEl: e.currentTarget,
                  selectedRow: data.id,
                  isSelected: true
                })
              }}
              disabled={(data.row.appointment_status === "Cancelled" || data.row.appointment_status === "No Show") ? true : false}
            >
              <MoreVertIcon />
            </IconButton>
          </Tooltip>
          {(this.state.isSelected && this.state.selectedRow == data.id) ?
            <Menu
              anchorEl={this.state.anchorEl}
              open={Boolean(this.state.anchorEl)}
              onClose={() => {
                this.setState({ anchorEl: null, })
              }}
            >
              {multi_option.map((option) => (
                <MenuItem key={option}
                  disabled={(((data.row.appointment_status !== "Completed" && data.row.appointment_status !== "With Doctor") || data.row.is_nurse)
                    && (option.label === "PrintDoctorNotes" || option.label === "PrintPrescription"))
                    || (data.row.is_nurse && option.label === "PresTem")
                    || (option.label === "TransAppoint" && data.row.appointment_status === "Completed")
                    || (this.state.selectedOption === option.value)
                    || (option?.label === 'TransAppoint' && (data?.row?.doctor_name === '' || data?.row?.doctor_name === "  "))
                    ? true : false}
                  onClick={() => { this.setState({ selectedOption: option.value, anchorEl: null, SelectedPatientDetails: data.row, tokenNum: data.row.token_number }) }}>
                  {t(option.label)}
                </MenuItem>
              ))}
            </Menu> : null}
        </div>
      </div>
    )
  }

  routeToDemograhics = (params) => {
    let { history } = this.props;
    setCachevalue(JSON.stringify(params?.row), "patientData")
    setCachevalue(JSON.stringify(this.state.datePicker), "SelectedOPDate")
    if (params.field === "patientDetails" || (params.field === "purpose_of_visit" && !this.state.onChangePov) || params.field === "appointment_start_time" || params.field === "bill_amount" || (params.field === "token_number" && !this.state.onAddComment)) {
      history.push({ pathname: "/OPHome/PatientDetails/Demographics" })
    }
  }
  handleClose = () => {
    this.setState({
      waitingCmts: false
    })
  }

  addComments = (value) => {
    var states = this.state
    if (this.state.waitCmtText) {
      var data1 = value.waiting_comment
      var data2 = []
      var date = new Date()
      var options = { timeZone: 'Asia/Kolkata', hour12: true, hour: 'numeric', minute: 'numeric' }
      var timeString = date.toLocaleTimeString('en-IN', options)
      data2.push({
        "date": DateTime.fromJSDate(date).toFormat('dd-MM-yyyy'),
        "time": timeString,
        "comments": states.waitCmtText.replace(/\s+/g, ' ').trim(),
      })
      var cmtData = [...data1, ...data2]
      this.setState({
        waitingCmts: false,
      })
      this.postPatientStatus('', states.SelectedPatientDetails.appointment_id, cmtData)
    } else {
      this.errorMsgFunc('Please Enter The Comment')
    }
  }

  povPopClose = () => {
    this.setState({
      povText: {},
      ispovPopOpen: false,
      onChangePov: false,
    })
  }

  renderWaitingCmt = (data) => {
    const { t } = this.props
    var states = this.state
    return (
      (states.SelectedPatientDetails.patient_id == data.patient_id && 
        states.SelectedPatientDetails?.appointment_id === data.appointment_id) ?
        <Dialog
          open={this.state.waitingCmts}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <div onClick={(e) => e.stopPropagation} className="eMed_DialogBox_Title" style={{ padding: '0.5vw' }}>
            <div>
              {t("WaitingComments")}
            </div>
            <div className="eMed_DialogBox_Close">
              <img className="eMed_DeletePopup_CrossIcon" src={ImagePaths.LabCloseButton.default} alt='Close' onClick={() => { this.setState({ waitingCmts: false, waitCmtText: '' }) }} />
            </div>
          </div>
          {
            data.appointment_status !== "Completed" ?
              <div>
                <DialogContent>
                  <TextField
                    sx={{ width: '25vw' }}
                    multiline
                    inputProps={{ maxLength: cmt_Char_limit }}
                    rows={3}
                    placeholder={t("AddComments")}
                    variant="outlined"
                    value={this.state.waitCmtText}
                    onChange={(e) => {
                      this.setState({ waitCmtText: e.target.value })
                    }} />
                </DialogContent>
                <DialogActions id="eMed_DialogBox_Btn">
                  <Button size="small" variant='outlined' id="eMed_Dia_Btn" onClick={() => { this.setState({ waitCmtText: '' }) }}>
                    {t('Clear')}
                  </Button>
                  <Button size="small" variant='contained' id="eMed_Dia_Btn" onClick={() => { this.addComments(data) }}>
                    {t('Add')}
                  </Button>

                </DialogActions>
              </div> : null
          }
          {data.waiting_comment.length > 0 ?
            <DialogContent id='eMed_OP_oldComments_Con'>
              <div className='eMed_OP_oldComments_Con1'>
                {data?.waiting_comment.map((item, index) => (
                  <div key = {`${item.comments}_${index}`} style={{ height: 'auto' }} >
                    <p className='eMed_OP_Cmts_Text'>{item.comments}</p>
                    <p className='eMed_OP_Cmts_Text1'>{item.time + ' | ' + item.date}</p>
                    <hr />
                  </div>
                ))}
              </div>
            </DialogContent> :
            <DialogContent id='eMed_OP_no_comments_div'>
              <Typography className='eMed_OP_no_comments_txt'>No Comments</Typography>
            </DialogContent>}
        </Dialog> : null
    )
  }

  waitTime = (data, id) => {
    let { AptTblData } = this.state;
    const result = calculateWaitingTime(data);
    const time = data.patient_arrived_time ? "Arrived: " + data.patient_arrived_time + " | " + (data.waiting_timer ? data.waiting_timer : result) : "-"

    AptTblData && AptTblData.length > 0 && (AptTblData).map((element, index) => {
      if (id === element.patient_id && element.timer != result && element.timer === undefined) {
        AptTblData[index]["timer"] = result === "NaN Hr NaN Mins." ? "0 Hr 0 Mins." : result
        this.setState({
          AptTblData
        })
      }
    })
    return (
      <Typography id='eMed_OP_AptTbl_AptText1' fontWeight={'bold'}>{time}</Typography>
    )
  }

  numberSort = (v1, v2) => {
    let sorted = gridNumberComparator(v1, v2);
    return sorted;
  }

  renderAptTable = () => {
    const { t } = this.props
    var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
    const appointmentStatusFromStorage = JSON.parse(localGetItem('appointment_status'));
    const loggedInUserInfo = myUser?.appointment_status;
    const appointmentStatus = appointmentStatusFromStorage || (loggedInUserInfo !== null ? loggedInUserInfo : appointment_Status_other);
    const checkedCount = appointmentStatus?.filter(item => item.is_checked).length;

    var UserData = myUser
    let isPovEdit = myUser?.is_user ? (myUser?.permission_access?.op?.is_pov_editable || false) : true;

    const columns = UserData?.module_name !== 'nurse' ? [
      {
        field: 'patientDetails', headerName: t('Patient Details'), headerClassName: 'eMed_Apt_TblHead', flex: 0.170,
        renderCell: (params) => (
          <NewCommonPatientDetails data={params.row} showTag={true} fromOp={true} />
        ), density: 'compact'
      },
      {
        field: 'token_number', headerName: t('AppointmentDetails'), headerClassName: 'eMed_Apt_TblHead', flex: 0.130, density: 'compact',
        renderCell: (params) => {
          let priorityLvl = params?.row?.appointment_type_priority ? params?.row?.appointment_type_priority : ''
          let bgColor = priorityLvl === "Priority_Level_1" ? "#1E972A" : priorityLvl === "Priority_Level_2" ? "#0461B7" : priorityLvl === "Priority_Level_3" ? "#DE7D24" : ''
          return (
            <div>
              <div className='eMed_OP_PatientType'> <Typography id='eMed_OP_AptTbl_AptText' sx={{ fontWeight: '600', color: bgColor ? 'white' : 'black', backgroundColor: bgColor, padding: bgColor ? '0.2vw' : '0', borderRadius: bgColor ? '0.4vw' : '0' }}>{'Token :' + (params.row.token_number ? params.row.token_number : '-')}</Typography>
                <div>{this.AppointmentTypeIcon(params.row.patient_appointment_types)}</div>
                {params.row.is_transfered ? this.AppointmentTypeIcon(params.row.is_transfered ? "transfer" : null) : null}
              </div>
              <div className='eMed_OP_AptTbl_Comment'>
                {(params.row.waiting_comment.length > 0 && params.row.waiting_comment[params.row.waiting_comment.length - 1].comments) ? (params.row.waiting_comment[params.row.waiting_comment.length - 1].comments).length > 14 ?
                  <Tooltip title={params.row.waiting_comment[params.row.waiting_comment.length - 1].comments} placement='top' arrow>
                    <Typography id='eMed_OP_AptTbl_AptText1'>{'WC : ' + params.row.waiting_comment[params.row.waiting_comment.length - 1].comments.slice(0, 12) + '...'}</Typography>
                  </Tooltip> : <Typography id='eMed_OP_AptTbl_AptText1'>{'WC : ' + params.row.waiting_comment[params.row.waiting_comment.length - 1].comments}</Typography>
                  : null
                }
                <Tooltip title={'Add Comments'} placement='top' arrow>
                  <div onClick={() => {
                    this.setState({
                      waitingCmts: true,
                      SelectedPatientDetails: params.row
                    })
                  }}
                    onMouseOver={() => { this.setState({ onAddComment: true }) }}
                    onMouseLeave={() => { this.setState({ onAddComment: false }) }}>
                    {(params.row.appointment_status === "Cancelled" || params.row.appointment_status === "No Show") ? null :
                      <img className='eMed_OP_Patient_Iconcircle' src={ImagePaths.Comments.default} alt='Comments' />}</div>
                </Tooltip>
                {this.state.waitingCmts ? this.renderWaitingCmt(params.row) : null}
              </div>
              <div>{params.row.doctor_name?.length > 12 ?
                <Tooltip title={params.row.doctor_name} placement={'top'} arrow>
                  <Typography id='eMed_OP_AptTbl_AptText'>{'Consultant :' + (params.row.doctor_name ? params.row.doctor_name.slice(0, 12) + '...' : '-')}</Typography>
                </Tooltip> : <Typography id='eMed_OP_AptTbl_AptText'>{(params.row?.is_nurse) ? 'Nurse :' + (params.row.nurse_name ? params.row.nurse_name : '-') : 'Consultant :' + (params.row.doctor_name ? params.row.doctor_name : '-')}</Typography>} </div>

            </div>)
        }, valueGetter: (params) => params.row.token_number, sortComparator: this.numberSort, sortingOrder: ['asc', 'desc']
      },
      {
        field: 'appointment_start_time', headerName: t('Arriving/WaitingTime'), headerClassName: 'eMed_Apt_TblHead', flex: 0.136, density: 'compact',
        renderCell: (params) => (
          <div>
            {this.waitTime(params.row, params.row.patient_id)}
            <Typography id='eMed_OP_AptTbl_AptText1'>{`Booked: ${params.row.appointment_start_time}`}</Typography>
          </div>
        )
      },
      {
        field: 'bill_amount', headerName: t('PaymentStatus'), headerClassName: 'eMed_Apt_TblHead', flex: 0.125, density: 'compact',
        renderCell: (params) => (
          <div>{this.PaymentStatus(params.row?.bill_amount ? params.row?.bill_amount : 0, params.row?.received_amount ? params.row?.received_amount : 0, params.row?.balance_details ? params.row?.balance_details : [])}</div>)
      },
      {
        field: 'purpose_of_visit', headerName: t('PurposeOfVisit'), headerClassName: 'eMed_Apt_TblHead', flex: 0.124, density: 'compact',
        renderCell: (params) => (
          <Box width={"100%"} display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
            {params.row.purpose_of_visit?.length > 16 ?
              <Tooltip title={params.row.purpose_of_visit} placement='top' arrow>
                <Typography>{params.row.purpose_of_visit.slice(0, 15) + '...'}</Typography>
              </Tooltip> : <Typography>{params.row.purpose_of_visit ? params.row.purpose_of_visit : "-"}</Typography>
            }
            {(isPovEdit && params.row.appointment_status !== "Cancelled" && params.row.appointment_status !== "Completed") ?
              <Tooltip title={'Edit'} placement='top' arrow>
                <div emed_tid={"fo_pov_edit"} size="small"
                  onClick={() => this.setState({
                    povText: params.row,
                    ispovPopOpen: true,
                  })}
                  onMouseOver={() => { this.setState({ onChangePov: true }) }}
                  onMouseLeave={() => { this.setState({ onChangePov: false }) }}>
                  <img src={ImagePaths.UserEditOn.default} className='eMed_list_image' alt='edit' />
                </div>
              </Tooltip> : null}
          </Box>)
      },
      {
        field: 'appointment_status', headerName: t('status'), headerClassName: 'eMed_Apt_TblHead', flex: checkedCount > 5 && checkedCount <= 9 ? 0.25 : 0.15, density: 'compact',
        renderCell: ({ row }) => (
          <Box display={'flex'} gap={'0.3vw'}>
            <div>{this.StatusBtns(row, row.appointment_id)}</div>
            {row?.appointment_change_status ? <Tooltip title={`Request for ${row?.appointment_change_status}` + (row?.appointment_change_status === "Reschedule" ? ` - Date: ${row?.appointment_changed_date ? row?.appointment_changed_date?.slice(0, 10)?.split('-')?.reverse()?.join('-') : '-'}` : row?.appointment_change_status === "Cancelled" ? ` - Reason: ${row?.reason_for_change}` : '')} placement='top' arrow><IconButton><img src={ImagePaths.Info.default} alt='Info' style={{ width: "1.2vw", height: "1.2vw" }} /></IconButton></Tooltip> : null}
          </Box>
        )
      },
      {
        field: 'action', headerName: t('Action'), headerClassName: 'eMed_Apt_TblHead', flex: 0.09, headerAlign: 'center', density: 'compact', sortable: false, hideable: false,
        renderCell: (params) => (
          <div>{this.ActionBtn(params)}</div>
        )
      }
    ] : [
      {
        field: 'patientDetails', headerName: t('Patient Details'), headerClassName: 'eMed_Apt_TblHead', flex: 0.170,
        renderCell: (params) => (
          <CommonPatientDetails data={params.row} showTag={true} fromOp={true} hideInsurance={true} />
        ), density: 'compact'
      },
      {
        field: 'token_number', headerName: t('AppointmentDetails'), headerClassName: 'eMed_Apt_TblHead', flex: 0.140, density: 'compact',
        renderCell: (params) => {
          let priorityLvl = params?.row?.appointment_type_priority ? params?.row?.appointment_type_priority : ''
          let bgColor = priorityLvl === "Priority_Level_1" ? "#1E972A" : priorityLvl === "Priority_Level_2" ? "#0461B7" : priorityLvl === "Priority_Level_3" ? "#DE7D24" : ''
          return (
            <div>
              <div className='eMed_OP_PatientType' style={{ backgroundColor: bgColor, justifyContent: bgColor ? 'center' : '' }}> <Typography id='eMed_OP_AptTbl_AptText' sx={{ fontWeight: '600' }}>{'Token :' + (params.row.token_number ? params.row.token_number : '-')}</Typography> <div>{this.AppointmentTypeIcon(params.row.appointment_patient_type === "transfer" ? params.row.appointment_patient_type : params.row.patient_appointment_types)}</div></div>
              <div className='eMed_OP_AptTbl_Comment'>
                {(params.row.waiting_comment.length > 0 && params.row.waiting_comment[params.row.waiting_comment.length - 1].comments) ? (params.row.waiting_comment[params.row.waiting_comment.length - 1].comments).length > 14 ?
                  <Tooltip title={params.row.waiting_comment[params.row.waiting_comment.length - 1].comments} placement='top' arrow>
                    <Typography id='eMed_OP_AptTbl_AptText1'>{'WC : ' + params.row.waiting_comment[params.row.waiting_comment.length - 1].comments.slice(0, 12) + '...'}</Typography>
                  </Tooltip> : <Typography id='eMed_OP_AptTbl_AptText1'>{'WC : ' + params.row.waiting_comment[params.row.waiting_comment.length - 1].comments}</Typography>
                  : <Typography id='eMed_OP_AptTbl_AptText1'>{"WC :  - "}</Typography>
                }
                <Tooltip title={'Add Comments'} placement='top' arrow>
                  <div onClick={() => { this.setState({ waitingCmts: true, SelectedPatientDetails: params.row }) }} onMouseOver={() => { this.setState({ onAddComment: true }) }} onMouseLeave={() => { this.setState({ onAddComment: false }) }}>{(params.row.appointment_status === "Cancelled" || params.row.appointment_status === "No Show") ? null : <img className='eMed_OP_Patient_Iconcircle' src={ImagePaths.Comments.default} alt='Comments' />}</div>
                </Tooltip>
                {this.state.waitingCmts ? this.renderWaitingCmt(params.row) : null}
              </div>
              <div>{params.row.doctor_name?.length > 12 ?
                <Tooltip title={params.row.doctor_name} placement={'top'} arrow>
                  <Typography id='eMed_OP_AptTbl_AptText'>{'Consultant :' + (params.row.doctor_name ? params.row.doctor_name.slice(0, 12) + '...' : '-')}</Typography>
                </Tooltip> : <Typography id='eMed_OP_AptTbl_AptText'>{'Consultant :' + (params.row.doctor_name ? params.row.doctor_name : '-')}</Typography>} </div>

            </div>)
        }, valueGetter: (params) => params.row.token_number, sortComparator: this.numberSort, sortingOrder: ['asc', 'desc']
      },
      {
        field: 'appointment_start_time', headerName: t('Arriving/WaitingTime'), headerClassName: 'eMed_Apt_TblHead', flex: 0.136, density: 'compact',
        renderCell: (params) => (
          <div>
            {this.waitTime(params.row, params.row.patient_id)}
            <Typography id='eMed_OP_AptTbl_AptText1' fontWeight={'bold'}>{`Booked: ${params.row.appointment_start_time}`}</Typography>
          </div>
        )
      },
      {
        field: 'bill_amount', headerName: t('PaymentStatus'), headerClassName: 'eMed_Apt_TblHead', flex: 0.125, density: 'compact',
        renderCell: (params) => (
          <div>{this.PaymentStatus(params.row?.bill_amount ? params.row?.bill_amount : 0, params.row?.received_amount ? params.row?.received_amount : 0)}</div>)
      },
      {
        field: 'purpose_of_visit', headerName: t('PurposeOfVisit'), headerClassName: 'eMed_Apt_TblHead', flex: 0.124, density: 'compact',
        renderCell: (params) => (
          <div>
            {params.row.purpose_of_visit?.length > 18 ?
              <Tooltip title={params.row.purpose_of_visit} placement='top' arrow>
                <Typography>{params.row.purpose_of_visit.slice(0, 18) + '...'}</Typography>
              </Tooltip> : <Typography>{params.row.purpose_of_visit ? params.row.purpose_of_visit : "-"}</Typography>
            }
          </div>)
      },
      {
        field: 'appointment_status', headerName: t('status'), headerClassName: 'eMed_Apt_TblHead', flex: checkedCount > 5 && checkedCount <= 8 ? 0.24 : 0.15, density: 'compact',
        renderCell: (params) => (
          <div>{this.StatusBtns(params.row, params.row.appointment_id)}</div>
        )
      },
    ]
    this.state.AptTblData.forEach((element, index) => { element.sno = index + 1 })
    return (

      <div>
        <Box className='eMed_AptTbl_Con'>
          <DataGrid
            rows={this.state.AptTblData}
            columns={columns}
            getRowId={(row) => row['sno']}
            pageSizeOptions={[10, 20, 30, 50]}
            pagination
            paginationMode="client"
            paginationModel={{
              page: this.state.page,
              pageSize: this.state.pageSize
            }}
            onPaginationModelChange={(model) => {
              this.setState({
                page: model.page,
                pageSize: model.pageSize
              });
            }}
            components={{
              Toolbar: CommonGridHeader.CommonToolBar,
              NoRowsOverlay: () => (
                <Stack className='eMed_conf_nodata'>
                  {t("NoRecordsFound")}
                </Stack>

              )
            }}
            localeText={{
              toolbarColumns: "",
              toolbarDensity: "",
              toolbarExport: "",
              toolbarFilters: "",
              toolbarExportPrint: ""
            }}
            density={'compact'}
            rowHeight={100}
            onCellClick={(params, events) => {
              if (this.state.waitingCmts) {
                events.stopPropagation();
                return;
              }
              (params.row.appointment_status === "Cancelled" || params.row.appointment_status === "No Show") ?
                null : this.routeToDemograhics(params)
            }}
            getRowHeight={(params) => {
              return 80
            }}
            disableRowSelectionOnClick
            loading={this.state.isLoader}
            getRowClassName={(params) => {
              if (params.row.appointment_status === "Cancelled" || params.row.appointment_status === "No Show") {
                return 'eMed_OP_CancelPatient'
              } else {
                return null
              }
            }}
          />
        </Box>
      </div>
    )
  }
  NxtAppiontmentClose() {
    setTimeout(() => { this.setState({ selectedOption: "" }) }, 1000)
  }
  NxtAppointmentSuccess(message) {
    this.setState({ selectedOption: "" }, () => {
      this.successMsgFunc(message)
      this.getPatientDetails()
    })
  }

  renderNxtApointmtPopup = () => {
    const { selectedOption, SelectedPatientDetails } = this.state;
    const commonProps = {
      PostSuccess: this.NxtAppointmentSuccess.bind(this),
      NxtAppiontmentClose: this.NxtAppiontmentClose.bind(this),
      PatientDetails: SelectedPatientDetails,
    };

    switch (selectedOption) {
      case "NextAppointment":
        return <NextAppointments {...commonProps} ScreenName="NextAppointment" />;
      case "Reschedule":
        return <NextAppointments {...commonProps} ScreenName="RescheduleAppiontment" />;
      case "PrintDoctorNotes":
        this.getPatientDoctorNotesPrint();
        break;
      case "PrintPrescription":
        this.getPatientPrescriptionPrint();
        break;
      case "CustomizedPrint":
        this.getCustomizedCardPrint();
        break;
      case "OpBarcode":
        this.getPatientOpCardPrint(false);
        break;
      case "OpCard":
        this.getPatientOpCardPrint(true);
        break;
      case "BillDetails":
        this.getPatientOpBillDetailPrint();
        break;
      case "SummaryBill":
        this.getPatientOpSummaryBillPrint();
        break;
      case "PrescriptionTemplate":
        this.getPatientPresTemplate();
        break;
      case "CommonBarcode":
        this.getCommonBarCodePrint();
        break;
      case "MedicalRecord":
        this.getMedicalRecordPrint();
        break;
      case "CancelAppontment":
        this.setState({ cancelAppointment: true, selectedOption: "" });
        break;
      case "ChangeTag":
        this.postChangeTagNormal();
        break;
      case "DataSheet":
        this.OPPatientDataSheetPrint();
        break;
      default:
        return null
    }
    this.setState({ selectedOption: "" });
  }

  postChangeTagNormal = () => {
    try {
      let data = {
        appointment_id: this.state.SelectedPatientDetails?.appointment_id,
        is_emergency: false
      }
      RestAPIService.create(data, Serviceurls.FO_IP_OP_PATIENT_TAG_CHANGE_NORMAL)
        .then((response) => {
          if (response?.data?.status === 'Success') {
            this.successMsgFunc(response.data.message)
            this.getPatientDetails()
            this.setState({ selectedOption: "" })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.setState({ selectedOption: "" })
            this.errorMsgFunc(error.response.data.message)
          } else {
            this.errorMsgFunc(error.message)
            this.setState({ selectedOption: "" })
          }
        })
    } catch (error) {
      this.setState({ selectedOption: "" })
      this.errorMsgFunc(error.message)
    }
  }

  popupClose = () => {
    this.setState({
      waitingCmts: false,
      cancelAppointment: false
    })
  }
  addCancelComments = (comments) => {
    const states = this.state;
    this.postPatientStatus('Cancelled', states.SelectedPatientDetails.appointment_id, comments, states.SelectedPatientDetails?.waiting_timer, states.SelectedPatientDetails)
    this.setState({
      cancelAppointment: false
    })
  }
  msgClose() {
    this.setState({
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }
  errorMsg() {
    this.setState({
      errormsg: this.props.error
    })
  }

  ReceiveClosePopUp() {
    this.setState({ OpPopupId: [] })
  }

  closeFilter = () => {
    this.setState({ FilterOpen: false })
  }

  ClearFilterData = () => {
    this.setState({
      Rescheduled: false,
      Cancelled: false,
      Transferred: false,
    })
  }

  renderFilterScreen = () => {
    const { t } = this.props
    return (
      <Box component={"div"} className='eMed_rts_filter_container'>
        <Box component={"div"} className='eMed_filter_Top'>
          <Typography variant='h6' fontWeight={600}>{t("Filter")}</Typography>
          <Button onClick={() => { this.setState({ FilterOpen: false }) }} className='eMed_usrconf_btn' emed_tid='opHome_filter_close_btn'>
            <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
          </Button>
        </Box>
        <Box className="eMed_Filter_Header">
          <Typography marginLeft={"1vw"}>{t("Patient Request")}</Typography>
        </Box>
        <Box className='eMed_rts_middle' display={'flex'} flexDirection={'column'} justifyContent={'space-between'}>
          <Box>
            <Box display={'flex'}>
              <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox sx={{ fontSize: '0.4vw' }} checked={this.state.Rescheduled} onChange={(e) => { this.setState({ Rescheduled: e.target.checked }) }} size='small' emed_tid='opHome_filter_rescheduled_checkBox' />} label={t("Rescheduled")} />
              <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox sx={{ fontSize: '0.4vw' }} checked={this.state.Cancelled} onChange={(e) => { this.setState({ Cancelled: e.target.checked }) }} size='small' emed_tid='opHome_filter_cancelled_checkBox' />} label={t("Cancelled")} />
              <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox sx={{ fontSize: '0.4vw' }} checked={this.state.Transferred} onChange={(e) => { this.setState({ Transferred: e.target.checked }) }} size='small' emed_tid='opHome_filter_transferred_checkBox' />} label={t("Transferred")} />
            </Box>
          </Box>

          <Stack spacing={2} direction="row" alignItems="center" justifyContent="center">
            <Button variant='outlined' size="small" emed_tid='opHome_filter_clear_btn'
              onClick={() => { this.ClearFilterData() }}
              id="eMed_Config_btn">{t("Clear")}</Button>
            <Button variant='contained' size="small" emed_tid='opHome_filter_search_btn' disabled={this.state.disableBtn}
              onClick={() => {
                this.getPatientDetails()
                this.setState({
                  FilterOpen: false
                })
              }}
              id="eMed_Config_btn">{t("Search")}</Button>
          </Stack>
        </Box>
      </Box>
    )
  }

  getSpecializationData = () => {
    try {
      RestAPIService.getAll(Serviceurls.FO_CONFIG_OPSPECIALIZATION)
        .then((response) => {
          if (response.data.status === 'success') {
            this.setState({
              specializationList: response.data.data.filter((item) => (item.is_active === true))
            })
          }
        }).catch(error => {
          if (error?.response?.data?.message) {
            this.errorMsgFunc(error.response.data.message)
          } else {
            this.errorMsgFunc(error.message)
          }
        })
    } catch (error) {
      this.errorMsgFunc(error.message)
    }
  }

  getTransListData = () => {
    try {
      let startDate = new Date(this.state.datePickerTrans)
      let date = DateTime.fromJSDate(startDate).toFormat('yyyy-MM-dd')
      RestAPIService.getAll(Serviceurls.DOC_TRANSFER_REQUEST + '?appointment_date=' + date)
        .then((response) => {
          if (response.data.status === 'success') {
            let dataList = response.data.data
            dataList?.forEach(element => {
              let gender = element?.gender === 'm' ? 'M' : element.gender === 'f' ? 'F' : 'T'
              element.patientDetails = `${element?.title} ${element?.first_name} ${element?.last_name} (${element.patient_age}/${gender})`
              element.patientUnidMob = `${element?.patient_account_number} | ${element?.patient_mobile}`
              element.doctorName = `${element.from_doctor__title} ${element?.from_doctor__first_name} ${element?.from_doctor__qualifications}`
              element.doctor_data = null
              element.specialization_data = null
            })
            this.setState({ transDataList: dataList })
          }
        }).catch(error => {
          if (error?.response?.data?.message) {
            this.errorMsgFunc(error.response.data.message)
          } else {
            this.errorMsgFunc(error.message)
          }
        })
    } catch (error) {
      this.errorMsgFunc(error.message)
    }
  }

  postTransferListData = (item, status) => {
    try {
      var data = {
        "id": item?.row?.id,
        "status": status,
      }
      if (status === 'Approved') {
        data['doctor_id'] = item?.row?.doctor_data?.doctor_id ? item?.row?.doctor_data?.doctor_id : item?.row?.doctor_id
      }
      if (data?.doctor_id === null && status === 'Approved') {
        this.errorMsgFunc('Select Doctor Name')
      } else {
        RestAPIService.updateWithOutId(data, Serviceurls.DOC_TRANSFER_REQUEST)
          .then((response) => {
            if (response.data.status === 'success') {
              this.successMsgFunc(response.data.message)
              this.getPatientDetails()
              this.getTransListData()
              // this.setState({ openTransferList: false })
            }
          }).catch(error => {
            if (error?.response?.data?.message) {
              this.errorMsgFunc(error.response.data.message)
            } else {
              this.errorMsgFunc(error.message)
            }
          })
      }
    } catch (error) {
      this.errorMsgFunc(error.message)
    }
  }

  renderTransferListPopup = () => {
    try {
      this.state.transDataList?.forEach((element, index) => element.sno = index + 1)
      const column = [
        {
          field: 'patientDetails', headerName: 'Patient Details', flex: 0.143,
          renderCell: (params) => {
            let patientName = params?.row?.patientDetails
            let patientAccMob = params?.row?.patientUnidMob
            return (
              <Box component={'div'}>
                {patientName ? patientName?.length > 20 ?
                  <Tooltip placement='top' title={patientName}><Box fontWeight={600} fontSize={'0.9vw'}>{patientName?.slice(0, 20) + '...'}</Box></Tooltip> :
                  <Box fontWeight={600} fontSize='0.9dvw'>{patientName}</Box> : '-'}
                {patientAccMob ? patientAccMob?.length > 20 ?
                  <Tooltip placement='top' title={patientAccMob}><Box fontSize={'0.8dvw'} color={Colors.grayShade}>{patientAccMob?.slice(0, 20) + '...'}</Box></Tooltip> :
                  <Box fontSize={'0.8dvw'} color={Colors.grayShade}>{patientAccMob}</Box> : '-'}
              </Box>
            )
          }
        },
        {
          field: 'from_doctor__first_name', headerName: 'Previous Consultant', flex: 0.143,
          renderCell: (params) => {
            let doctorName = params?.row?.doctorName
            let specialisation = params?.row?.specialization_name
            return (
              <Box>
                {doctorName ? doctorName?.length > 12 ?
                  <Tooltip placement='top' title={doctorName}><Box fontSize={'0.9dvw'} fontWeight={600}>{doctorName?.slice(0, 12) + '...'}</Box></Tooltip> :
                  <Box fontSize={'0.9dvw'} fontWeight={600}>{doctorName}</Box> : '-'}
                {specialisation ? specialisation?.length > 12 ?
                  <Tooltip placement='top' title={specialisation}><Box fontSize={'0.8dvw'} color={Colors.grayShade}>{specialisation?.slice(0, 12) + '...'}</Box></Tooltip> :
                  <Box fontSize={'0.8dvw'} color={Colors.grayShade}>{specialisation}</Box> : '-'}
              </Box>
            )
          }
        },
        {
          field: 'purpose_of_visit', headerName: 'Purpose of Visit', flex: 0.143,
          renderCell: (params) => {
            let pov = params?.row?.purpose_of_visit
            return (
              pov ? pov?.length > 15 ?
                <Tooltip placement='top' title={pov}><Box>{pov?.slice(0, 15) + '...'}</Box></Tooltip> :
                pov : '-'
            )
          }
        },
        {
          field: 'transfer_notes', headerName: 'Transfer Notes', flex: 0.11,
          renderCell: (params) => {
            let notes = params?.row?.transfer_notes
            return (
              <Box>
                {notes ? notes?.length > 15 ?
                  <Tooltip placement='top' title={notes}><Box>{notes?.slice(0, 15) + '...'}</Box></Tooltip> :
                  notes : '-'}
              </Box>
            )
          }
        },
        {
          field: 'specilaization', headerName: 'Specializiation', flex: 0.183,
          renderCell: (params) => {
            let specialization = params?.row?.specialization_name
            return (
              <Box component={'div'}>
                {specialization ? specialization?.length > 20 ?
                  <Tooltip placement='top' title={specialization}><Box>{specialization?.slice(0, 20) + '...'}</Box></Tooltip> :
                  specialization : '-'}
              </Box>
            )
          }
        },
        {
          field: 'Doctor Name', headerName: 'Doctor Name', flex: 0.183,
          renderCell: (params) => {
            let docName = params?.row?.doctor_name
            return (
              <Box component={'div'}>
                {docName ?
                  docName ? docName?.length > 20 ?
                    <Tooltip placement='top' title={docName}><Box>{docName?.slice(0, 20) + '...'}</Box></Tooltip> :
                    docName : '-' :
                  <Autocomplete
                    clearIcon
                    size='small'
                    sx={{ width: '12dvw' }}
                    options={this.state.DoctorsList?.filter(item => item?.specialization_name === params?.row?.specialization_name)}
                    getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.doctor_name}
                    value={params?.row?.doctor_name || params?.row?.doctor_data}
                    onChange={(e, newValue) => {
                      let transData = [...this.state.transDataList]
                      transData[params?.row?.sno - 1] = { ...transData[params?.row?.sno - 1], doctor_data: newValue }
                      this.setState({ transDataList: transData })
                    }}

                    renderInput={(params) => <TextField {...params} placeholder='Select Doctor Name' />}
                  />}
              </Box>
            )
          }
        },
        {
          field: 'action', headerName: 'Action', flex: 0.1,
          renderCell: (params) => {
            return (
              <Box component={'div'}>
                <Tooltip placement='top' title='Create Appointment'><Button
                  className='Common_Btn_Min_Width'
                  startIcon={<CheckCircleOutlineIcon color='primary' />}
                  onClick={() => this.postTransferListData(params, 'Approved')}
                /></Tooltip>
                <Tooltip placement='top' title={'Cancel'}>
                  <Button
                    className='Common_Btn_Min_Width'
                    startIcon={<CancelIcon color='error' />}
                    onClick={() => this.postTransferListData(params, 'Cancelled')}
                  ></Button>
                </Tooltip>
              </Box>
            )
          }
        },
      ]
      return (
        <Box component={'div'}>
          <Dialog
            open={this.state.openTransferList}
            maxWidth="lg"
            fullWidth
          >
            <Box className='emedhub_popup_lobby' p={'1rem'}>
              <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                <Box component={'div'} display={'flex'} alignItems={'center'} mb={'0.5rem'}>
                  <Typography fontSize={'0.9dvw'} fontWeight={600} mr={'1rem'}>Transferred List</Typography>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      open={this.state.transDatePickerOpen}
                      onOpen={() => { this.setState({ transDatePickerOpen: true }) }}
                      onClose={() => { this.setState({ transDatePickerOpen: false }) }}
                      value={this.state.datePickerTrans}
                      name={"datePicker"}
                      inputFormat='DD-MM-YYYY'
                      views={["year", "month", "day"]}
                      onChange={(newDate) => {
                        this.setState({ datePickerTrans: newDate }, () => this.getTransListData());
                      }}
                      renderInput={(params) => (
                        <TextField
                          onKeyDown={(e) => e.preventDefault()}
                          style={{ width: '10vw' }}
                          size='small'
                          {...params}
                          onClick={() => { this.setState({ transDatePickerOpen: true }) }}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Box>
                <Button
                  className='Common_Btn_Min_Width'
                  onClick={() => this.setState({ openTransferList: false })}
                >
                  <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1dvw'} width={'1dvw'} />
                </Button>
              </Box>
              <Box component={'div'} height={'30dvw'}>
                <DataGrid
                  columns={column}
                  rows={this.state.transDataList}
                  getRowId={(row) => row['sno']}
                  page={this.state.transPage}
                  pageSize={this.state.transPageSize}
                  localeText={{
                    toolbarColumns: "",
                    toolbarDensity: "",
                    toolbarExport: "",
                    toolbarFilters: "",
                    toolbarExportPrint: ""
                  }}
                  components={{
                    NoRowsOverlay: () => (
                      <Box className='' sx={{ position: 'relative', top: '10vw', left: '33vw' }}>
                        {'No Records To Be Shown'}
                      </Box>
                    )
                  }}
                  pagination
                  paginationMode="client"
                  paginationModel={{
                    page: this.state.transPage,
                    pageSize: this.state.transPageSize
                  }}
                  onPaginationModelChange={(model) => {
                    this.setState({
                      transPage: model.page,
                      transPageSize: model.pageSize
                    });
                  }}
                  pageSizeOptions={[10, 20, 30]}
                  headerHeight={40}
                  disableRowSelectionOnClick
                  loading={this.state.loading}
                />
              </Box>
            </Box>
          </Dialog>
        </Box>
      )
    } catch (error) {
      this.errorMsgFunc(error.message)
    }
  }

  balanceViewPopup = () => {
    return (
      <Box component={'div'}>
        <Modal
          open={this.state.balanceVisible}
        >
          <Box component={'div'} className="eMed_BalancePop_style">
            <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} p={'0.5vw'} borderBottom={'1px solid lightgray'}>
              <Typography fontSize={'0.9vw'} fontWeight={600}>Balance Status</Typography>
              <Button
                className="Common_Btn_Min_Width"
                onClick={() => this.setState({ balanceVisible: false, balance_details: {}, balanceAmount: null })}
              >
                <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1vw'} width={'1vw'} />
              </Button>
            </Box>
            <Box component={'div'} display={'flex'} justifyContent={'center'} p={'0.5vw'}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ backgroundColor: Colors.Background, fontSize: '0.9vw', fontWeight: 600, color: Colors.SecondaryText }}>
                      Department
                    </TableCell>
                    <TableCell sx={{ backgroundColor: Colors.Background, fontSize: '0.9vw', fontWeight: 600, color: Colors.SecondaryText }}>
                      Balance
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.balance_details && Object.entries(this.state.balance_details).length > 0 ? (
                    Object.entries(this.state.balance_details).map(([dept, balance], index) => (
                      <TableRow key={index}>
                        <TableCell sx={{ textTransform: "capitalize" }}>
                          {dept.length > 20 ? (
                            <Tooltip placement="top" title={dept}>
                              <div>{dept.slice(0, 20) + '...'}</div>
                            </Tooltip>
                          ) : (dept)}
                        </TableCell>
                        <TableCell>{balance}</TableCell>
                      </TableRow>
                    ))
                  ) : <TableRow>
                    <TableCell />
                    <TableCell>No Records</TableCell>
                  </TableRow>}
                </TableBody>
              </Table>
            </Box>
            <Box component={'div'} display={'flex'} p={'0.5vw'}>
              <span style={{ width: "14dvw", paddingLeft: "1dvw" }}>Total Balance Amount  </span>
              <span style={{ width: "13dvw", paddingLeft: "1dvw" }}>{this.state?.balanceAmount.toFixed(2)}</span>
            </Box>
          </Box>
        </Modal>
      </Box>
    )
  }

  render() {
    return (
      <div className='eMed_OP_Appointment'>
        {this.renderOPHeader()}
        {this.renderPatientType()}
        {this.renderAptTable()}
        {this.state.selectedOption != "" ? this.renderNxtApointmtPopup() : null}

        {this.state.selectedOption === "TransAppoint" ?
          <NextAppointments
            PostSuccess={this.NxtAppointmentSuccess.bind(this)}
            NxtAppiontmentClose={this.NxtAppiontmentClose.bind(this)}
            getPatientDetails={this.getPatientDetails.bind(this)}
            ScreenName={"TransAppoint"}
            PatientDetails={this.state.SelectedPatientDetails}
            AppointmentDate={this.state.datePicker}
            disableDatePicker={true}
            AppointmentType={true} /> : null
        }

        {this.state.cancelAppointment ? <ReasonPopup
          title={"Are you sure? Do you want to cancel the appointment"}
          AlertPopupClose={this.popupClose.bind(this)}
          label={"Enter the Reason"}
          btntext={'Cancel'}
          btnvarient={'outlined'}
          btncolor={'error'}
          btntext1={'Confirm'}
          btnvarient1={'contained'}
          sendCmt={this.addCancelComments.bind(this)} /> : null}
        {this.state.OpPopupId?.length > 0 ?
          <BillSuccessPoPUp isFromOPHome={true} BilllistArray={this.state.OpPopupId} CloseBtnText={'close'} ClosePopUp={this.ReceiveClosePopUp.bind(this)} error={this.errorMsgFunc.bind(this)} /> : null}

        <Drawer
          anchor={'right'}
          open={this.state.FilterOpen}
          ModalProps={{ onBackdropClick: this.closeFilter }}
        >
          {this.renderFilterScreen()}
        </Drawer>
        {this.state.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={this.state.isErrorMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
        {this.state.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={this.state.successMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
        {this.state.receiptID !== null ?
          <BillSuccessPoPUp creditreceipt={this.state.receiptID} phrma_creditreceipt={this.state.pharmacReceipt} ClosePopUp={this.ClosesuccessPopUp.bind(this)} />
          : null}

        {this.state.ispovPopOpen ?
          <PovEditPopup
            povEditText={this.state.povText.purpose_of_visit}
            povData={this.state.povText}
            getTableData={this.getPatientDetails.bind(this)}
            AlertPopupClose={this.povPopClose.bind(this)}
            successMsg={this.successMsgFunc.bind(this)}
            errorMsg={this.errorMsgFunc.bind(this)}
          /> : null}
        {this.state.balanceVisible ?
          this.balanceViewPopup()
          : null
        }
        {this.renderTransferListPopup()}
      </div>

    )
  }
}

export default withTranslation()(OutpatientHome);